import * as React from 'react';
import styled, { keyframes } from 'styled-components';

import { BREAKPOINTS, COLORS, focusStyles } from '../../styles';
import { VerticalTabs } from '../../Tabs';
import { VerticalTabEntry } from '../../Tabs';
import {MenuNavigationItemTypeItem, Size} from '../../index';
import {Z_INDEXES} from '../../styles';

export const flowDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Menu = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: ${props => COLORS.getColor('white', props.theme)};
  box-sizing: border-box;
  display: none;
  right: -8px;
  min-width: 300px;
  -webkit-animation: ${flowDown} 0.2s ease-in-out;
  animation: ${flowDown} 0.2s ease-in-out;
  position: absolute;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: ${Z_INDEXES.dropdown};

  top: 12px;
  ${BREAKPOINTS.SMALL} {
    top: 18px;
  }
  ${BREAKPOINTS.MEDIUM} {
    top: 24px;
  }

  .open & {
    display: block;
  }

  &:focus {
    ${focusStyles}
  }
`;

export const MenuSection = styled.li`
  padding: 8px 0;
  position: relative;

  &:not(:first-of-type)::before {
    content: '';
    position: absolute;
    background: ${props => COLORS.getColor('neutral_100', props.theme)};
    height: 1px;
    top: 0;
    left: 16px;
    right: 16px;
  }
`;

export const MenuSectionList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 2px;
`;

type Props = {
  clickMenuAction: () => void;
  navigationOptions: MenuNavigationItemTypeItem[];
};

const ExtendedMainMenu = ({ clickMenuAction, navigationOptions }: Props) => {
  const [entries, setEntries] = React.useState<VerticalTabEntry[]>([]);
  React.useEffect(() => {
    function handleKeyPress(e: any) {
      if (e.keyCode === 27) {
        clickMenuAction();
      }
    }

    document.addEventListener('keydown', handleKeyPress, false);
    return () => {
      document.removeEventListener('keydown', handleKeyPress, false);
    };
  }, [clickMenuAction]);

  React.useEffect(() => {
    const list = navigationOptions?.map(n => {
      return { requiredLine: n.label, to: n.to, disabled: n.disabled, onClick: n.action, exact: n.exact };
    }) as VerticalTabEntry[];
    setEntries(list);
  }, [navigationOptions]);

  return (
    <Menu onClick={clickMenuAction} role="menu" aria-labelledby="UserMenuButton">
      <MenuSection>
        <MenuSectionList>
          <VerticalTabs key="ExtendedMenu" entries={entries} size={Size.Medium} />
        </MenuSectionList>
      </MenuSection>
    </Menu>
  );
};

export default ExtendedMainMenu;
